import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PieChartComponent } from '../../../../components/chart/pie-chart/pie-chart.component';

@Component({
  selector: 'app-defect-severity-distribution',
  standalone: true,
  imports: [CommonModule, PieChartComponent, FormsModule],
  templateUrl: './defect-severity-distribution.component.html',
  styleUrl: './defect-severity-distribution.component.scss'
})
export class DefectSeverityDistributionComponent {

  @Input() 
  data: any;

  @Input() 
  meta: any;

  @Input()
  name: string = '';

  @Input() 
  metricDisplayName: string = '';
  
  selectedView: string = 'overall';
  testSuites: string[] = [];
  selectedTestSuite: string = '';
  
  ngOnInit() {
    // Extract test suites from data if available
    console.log("Data:", this.data);
    if (this.data && Array.isArray(this.data)) {
      this.testSuites = this.data
        .filter((item: any) => item.suiteName)
        .map((item: any) => item.suiteName);
      console.log("Test Suites:", this.testSuites);
    }
  }

  getChartData() {
    if (this.selectedView === 'overall') {
      return this.getOverallData();
    } else {
      return this.getTestSuiteData();
    }
  }

  getOverallData() {
    if (this.data && Array.isArray(this.data)) {
      // Aggregate all suite data
      const aggregated: any = {};
      this.data.forEach((suite: any) => {
        // Iterate through severity keys in each suite
        Object.keys(suite).forEach((key) => {
          if (key !== 'suiteName' && typeof suite[key] === 'number') {
            aggregated[key] = (aggregated[key] || 0) + suite[key];
          }
        });
      });
      return aggregated;
    }
    return {};
  }

  getTestSuiteData() {
    if (this.selectedTestSuite && Array.isArray(this.data)) {
      const selectedSuite = this.data.find((suite: any) => suite.suiteName === this.selectedTestSuite);
      if (selectedSuite) {
        // Return suite data excluding suiteName property
        const { suiteName, ...severityData } = selectedSuite;
        return severityData;
      }
    }
    return {};
  }

  getChartMeta() {
    return {
      isLegendVisible: false
    };
  }

  getSeverities() {
    const data = this.getChartData();
    const severityOrder = ['critical', 'high', 'medium', 'low', 'major', 'minor'];
    
    return severityOrder
      .filter(severity => data[severity] !== undefined && data[severity] > 0)
      .map(severity => ({
        name: severity,
        value: data[severity],
        percentage: this.getPercentage(severity)
      }));
  }

  getPercentage(severity: string): number {
    const data = this.getChartData();
    const total = Object.values(data).reduce((sum: number, val: any) => sum + (Number(val) || 0), 0);
    if (total === 0) return 0;
    
    const value = data[severity] || 0;
    return Math.round((value / total) * 100);
  }

  getSeverityColor(severity: string): string {
    const colorMap: any = {
      'critical': '#FC404A',
      'high': '#5F2CFF',
      'medium': '#FEC901',
      'low': '#D0D2D4',
      'major': '#FF9999',
      'minor': '#DED6FF'
    };
    return colorMap[severity.toLowerCase()] || '#D0D2D4';
  }

  getSeverityLabel(severity: string): string {
    return severity.charAt(0).toUpperCase() + severity.slice(1);
  }

  onViewChange(view: string) {
    this.selectedView = view;
    if (view === 'overall') {
      this.selectedTestSuite = '';
    }
  }

  onTestSuiteChange() {
    // Switch to testSuite view when a suite is selected
    if (this.selectedTestSuite) {
      this.selectedView = 'testSuite';
    }
  }

  getChartColors() {
    const data = this.getChartData();
    return Object.keys(data).map(severity => this.getSeverityColor(severity));
  }
}
